import moment from 'moment';
import validateField from './validateField';
import numberFormat from './numberFormat';
import axios from 'axios';
import { DEFAULT_DATE_FORMAT } from '@/config/constants';

const formatDateTimeZone = (format = 'YYYY/MM/DD (dddd)', dateTime = null, withHour = false) => {
    let time = withHour ? new Date(dateTime).getTime() : new Date(dateTime).getTime();
    let momentTime = dateTime ? moment(time) : moment();
    return momentTime.format(format);
};
const formatDateTimeZoneWithHour = (format, dateTime = null) => {
    let momentTime = dateTime ? moment(dateTime) : moment();
    return momentTime.format(format).replaceAll('+07:00', '+09:00');
};

const formatDateTime = (dateTime = null, format = DEFAULT_DATE_FORMAT) => {
    return formatDateTimeZone(format, dateTime, true);
};

const fomatDateTimeLocal = (format = 'YYYY-mm-dd hh:mm:ss', dateTime = null) => {
    let dateTimeNew = dateTime;
    let time = new Date(dateTimeNew).getTime();
    let d = time;
    let momentTime = dateTime ? moment(d) : moment();
    return momentTime.format(format);
};

const formatDateTimeLocalKintone = (format = 'YYYY-mm-dd hh:mm:ss', dateTime = null) => {
    let dateTimeNew = dateTime.replaceAll('-', '/');
    let offset = new Date().getTimezoneOffset();
    let time = new Date(dateTimeNew).getTime();
    let d = time + offset * -1 * 60 * 1000;
    let momentTime = dateTime ? moment(d) : moment();
    return momentTime.format(format);
};

const formatDateCurrent = (dateTime = null, format = DEFAULT_DATE_FORMAT) => {
    let d = new Date();
    let momentTime = dateTime ? moment(d) : moment();
    return momentTime.format(format);
};

const validPassword = (password) => {
    let re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,}).{8,32}$/;
    return re.test(password);
};
const validDuplicator = (duplicator) => {
    let re = /^((?:(.)(?!\2{2}))+)*$/;
    return re.test(duplicator);
};

const validEmail = (email) => {
    let arrSpecialText = ['!', '#', '$', '%', '^', '&', '*', '(', ')', ',', '/', '|'];
    let checkSpecialText = true;
    if (email) {
        let arrText = email.split('') || [];
        arrText.map((elm) => {
            if (arrSpecialText.includes(elm)) {
                checkSpecialText = false;
            }
        });
    }
    if (checkSpecialText) {
        let re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    } else {
        return false;
    }
};
const groupByData = (objectArray, property) => {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
};

const validNumber = (number) => {
    let reg = new RegExp('^[0-9]+$');
    return reg.test(number);
};

const formatNumber = (n) => {
    return n !== null ? n.toString().replace(/[,]+/g, '') : n;
};

const validAppVersion = (number) => {
    let regex = '^[0-9]+(\\.[0-9]*)*$';

    let reg = new RegExp(regex);
    return reg.test(number);
};

const checkScientificNumber = (number) => {
    let data = String(number).split(/[eE]/);
    if (data.length === 1) {
        return { number: data[0], isScientific: false };
    }

    let z = '';
    let sign = number < 0 ? '-' : '';
    let str = data[0].replace('.', '');
    let mag = Number(data[1]) + 1;

    if (mag < 0) {
        z = sign + '0.';
        while (mag++) z += '0';
        return {
            number: z + str.replace(/^-/, ''),
            isScientific: true
        };
    }
    mag -= str.length;
    while (mag--) z += '0';
    return {
        number: str + z,
        isScientific: true
    };
};

const convertToHalfsize = (chars) => {
    let ascii = '';
    for (let i = 0, l = chars.length; i < l; i++) {
        let c = chars[i].charCodeAt(0);
        if (c === 12290) {
            c = 46;
        }
        if (c >= 0xff00 && c <= 0xffef) {
            c = 0xff & (c + 0x20);
        }

        ascii += String.fromCharCode(c);
    }

    return formatNumber(ascii);
};

const validNegativeNumber = (number, decimal = false, precision = 0) => {
    let regex = '^-?[0-9]{0,16}$';

    if (decimal) {
        if (precision) {
            regex = `^((-?[0-9]{0,16})|(-?[0-9]{1,16}\\.[0-9]{0,${precision}}?))$`;
        } else {
            regex = '^((-?[0-9]{0,16})|(-?[0-9]{1,16}\\.[0-9]*?))$';
        }
    }

    let reg = new RegExp(regex);
    return reg.test(number);
};

const validPrice = (number) => {
    let reg = new RegExp('^[0-9.]+$');
    return reg.test(number);
};

const validPhoneNumber = (phoneNumber) => {
    let reg = /^[0-9()+-\s]+$/;
    return reg.test(phoneNumber);
};

const exportData = (path, filename) => {
    const link = document.createElement('a');
    link.href = path;
    if (filename) link.download = filename;
    document.body.appendChild(link);
    window.open(path, '_blank');
};

const forceDownloadFile = (url, filename) => {
    axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
    }).then((response) => {
        const href = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
    });
};

const convertUrlToBlob = (url) => {
    return fetch(url)
        .then((response) => {
            return response.blob();
        })
        .then((blob) => {
            return URL.createObjectURL(blob);
        });
};

const customGetDay = (day) => {
    let result = day.getDay();
    return result;
};

const renderClassForSelect = (id) => {
    let className = `custom-width-for-${id}`;
    let selectEle = document.getElementById(id);
    if (selectEle !== null) {
        let style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = `.${className} { width: ${selectEle.offsetWidth}px !important; }`;
        document.getElementsByTagName('head')[0].appendChild(style);
    }
    return className;
};

const searchStringInArray = (keyword, array) => {
    keyword = convertJapaneseText(keyword).toLowerCase();

    return array
        .map((item) => {
            return item ? convertJapaneseText(item).toLowerCase() : '';
        })
        .some((item) => {
            return convertJapaneseText(item).toLowerCase().indexOf(keyword) !== -1;
        });
};

const convertJapaneseText = (keyword) => {
    let temp = window.hepburn.fromKana(keyword);
    temp = window.hepburn.toKatakana(temp);
    let smallCode = [
        { small: 0x30a1, big: 0x30a2 },
        { small: 0x30a3, big: 0x30a4 },
        { small: 0x30a5, big: 0x30a6 },
        { small: 0x30a7, big: 0x30a8 },
        { small: 0x30a9, big: 0x30aa },
        { small: 0x30c3, big: 0x30c4 },
        { small: 0x30e3, big: 0x30e4 },
        { small: 0x30e5, big: 0x30e6 },
        { small: 0x30e7, big: 0x30e8 },
        { small: 0x30ee, big: 0x30ef },
        { small: 0x30f5, big: 0x30ab },
        { small: 0x30f6, big: 0x30b1 },
        { small: 0x31f0, big: 0x30af },
        { small: 0x31f1, big: 0x30b7 },
        { small: 0x31f2, big: 0x30b9 },
        { small: 0x31f3, big: 0x30c8 },
        { small: 0x31f4, big: 0x30cc },
        { small: 0x31f5, big: 0x30cf },
        { small: 0x31f6, big: 0x30d2 },
        { small: 0x31f7, big: 0x30d5 },
        { small: 0x31f8, big: 0x30d8 },
        { small: 0x31f9, big: 0x30db },
        { small: 0x31fa, big: 0x30e0 },
        { small: 0x31fb, big: 0x30e9 },
        { small: 0x31fc, big: 0x30ea },
        { small: 0x31fd, big: 0x30eb },
        { small: 0x31fe, big: 0x30ec },
        { small: 0x31ff, big: 0x30ed }
    ];
    let result = '';
    for (let i = 0; i < temp.length; i++) {
        let code = temp[i].charCodeAt(0);
        let findCode = smallCode.findIndex((x) => x.small === code);
        if (findCode > -1) {
            result += String.fromCharCode(smallCode[findCode].big);
        } else {
            result += temp[i];
        }
    }
    return result;
};

const cloneArrayObject = (array) => {
    return array.map((item) => {
        return Object.assign({}, item);
    });
};

const currencyFormat = (number) => {
    return new Intl.NumberFormat('ja-JP').format(number) + ` ${window.$i18n.t('yen')}`;
};

const getQueryString = (model) => {
    let query = [`page=${model.page}`, `limit=${model.limit}`];

    model.sorts.forEach((sort) => {
        query.push(`sorts[${sort.field}]=${sort.order}`);
    });

    for (let field in model.filters) {
        if (model.filters[field]) {
            query.push(`filters[${field}]=${model.filters[field]}`);
        }
    }

    if (model.search) {
        this.searchFields.forEach((field) => {
            query.push(`search[${field}]=${model.search}`);
        });
    }

    return query.join('&');
};

const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

const getQuantityLabel = (value, materialInfo) => {
    let label = [];

    label.push(value || 0);

    if (materialInfo && materialInfo.unit_info) {
        label.push(materialInfo.unit_info.name);
    }

    return label.join(' ');
};

const sortCallback = (before, after, order) => {
    if (order === 'asc') {
        return sortCallbackAsc(before, after, order);
    } else {
        return sortCallbackDesc(before, after, order);
    }
};

const sortCallbackAsc = (before, after) => {
    if (before < after) {
        return -1;
    }

    if (before > after) {
        return 1;
    }

    return 0;
};

function isIsoDate(str) {
    return !!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/.test(str);
}

const sortCallbackDesc = (before, after) => {
    if (before < after) {
        return 1;
    }

    if (before > after) {
        return -1;
    }

    return 0;
};

const getFailureMessage = (message, row) => {
    message = message.split('.');

    if (message.length && parseInt(message[0]) === row) {
        message.shift();
    }

    return message.join('.');
};

const validURL = (url) => {
    let regexUrl = "^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]@!\\$&'\\(\\)\\*\\+,;=.]+$";
    let reg = new RegExp(regexUrl);
    return reg.test(url);
};

const addComasNumber = (n) => {
    if (!n) return '0';
    return n.toLocaleString('en');
};

const generateStorageKey = (key, scs = true) => {
    let environmentKey = scs ? process.env.VUE_APP_SCS_KEY_CONSTANT : process.env.VUE_APP_KEY_CONSTANT;
    return environmentKey ? `${environmentKey}_${key}` : key;
};

const deepCopy = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }
    if (obj instanceof Array) {
        return obj.reduce((arr, item, i) => {
            arr[i] = deepCopy(item);
            return arr;
        }, []);
    }
    if (obj instanceof Object) {
        return Object.keys(obj).reduce((newObj, key) => {
            newObj[key] = deepCopy(obj[key]);
            return newObj;
        }, {});
    }
};

const dataURItoBlob = (dataURL) => {
    let BASE64_MARKER = ';base64,';
    if (dataURL.indexOf(BASE64_MARKER) === -1) {
        let parts = dataURL.split(',');
        let contentType = parts[0].split(':')[1];
        let raw = decodeURIComponent(parts[1]);
        return new Blob([raw], { type: contentType });
    }
    let parts = dataURL.split(BASE64_MARKER);
    let contentType = parts[0].split(':')[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;
    let uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
};

const resizeImage = ({ file, maxSize }) => {
    const reader = new FileReader();
    const image = new Image();
    const canvas = document.createElement('canvas');
    const resize = () => {
        let { width, height } = image;
        let count = 0;
        let data = width >= height ? width : height;
        let numberCheck = 50;
        if (data > 5000) {
            numberCheck = 1500;
        } else if (data > 2000 && data < 5000) {
            numberCheck = 1000;
        } else if (data > 500 && data < 2000) {
            numberCheck = 300;
        }
        for (let i = data; i > 0; i = i - numberCheck) {
            if (width > height) {
                if (width > i) {
                    height *= i / width;
                    width = i;
                }
            } else if (height > i) {
                width *= i / height;
                height = i;
            }

            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);

            const dataUrl = canvas.toDataURL('image/jpeg');
            const bytes = dataUrl.split(',')[0].indexOf('base64') >= 0 ? atob(dataUrl.split(',')[1]) : unescape(dataUrl.split(',')[1]);
            if (bytes.length <= maxSize) {
                count++;
                return dataURItoBlob(dataUrl);
            }
            if (count === 1) break;
        }
    };
    return new Promise(function (resolve, reject) {
        if (!file.type.match(/image.*/)) {
            return reject(new Error('Not an image'));
        }
        reader.onload = (readerEvent) => {
            image.onload = () => resolve(resize());
            image.src = readerEvent.target.result;
        };

        reader.readAsDataURL(file);
    });
};
const blobToFile = (theBlob, fileName) => {
    return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type });
};

const validMaxLength = (value, numberLength = 255) => {
    let result = true;
    if (value) {
        if (value.length > numberLength) {
            result = false;
        }
    }
    return result;
};

const validRequired = (value, isNumber = false) => {
    if (isNumber) {
        if (value && Number(value) > 0) {
            return true;
        } else {
            return false;
        }
    } else {
        if (value && value.trim().length > 0) {
            return true;
        } else {
            return false;
        }
    }
};
const isEmpty = function (val) {
    // null or undefined
    if (val == null) return true;

    if (typeof val === 'boolean') return false;

    if (typeof val === 'number') return !val;

    if (val instanceof Error) return val.message === '';

    switch (Object.prototype.toString.call(val)) {
        // String or Array
        case '[object String]':
        case '[object Array]':
            return !val.length;

        // Map or Set or File
        case '[object File]':
        case '[object Map]':
        case '[object Set]': {
            return !val.size;
        }
        // Plain Object
        case '[object Object]': {
            return !Object.keys(val).length;
        }
    }

    return false;
};
const checkStatusExport = function (item) {
    if (item.status === 3) {
        return 'エラー';
    }

    if (item.status === 2) {
        return '完了';
    }

    if (item.status === 1) {
        return '処理中';
    }

    if (item.status === 0) {
        return '処理を開始する';
    }
    return '';
};

export {
    validateField,
    numberFormat,
    addComasNumber,
    formatDateTime,
    validEmail,
    validNumber,
    exportData,
    convertUrlToBlob,
    validPhoneNumber,
    validPrice,
    customGetDay,
    renderClassForSelect,
    validNegativeNumber,
    searchStringInArray,
    cloneArrayObject,
    currencyFormat,
    getQueryString,
    forceDownloadFile,
    capitalizeFirstLetter,
    getQuantityLabel,
    sortCallback,
    getFailureMessage,
    convertToHalfsize,
    checkScientificNumber,
    validAppVersion,
    validURL,
    formatNumber,
    generateStorageKey,
    deepCopy,
    convertJapaneseText,
    resizeImage,
    blobToFile,
    validRequired,
    validDuplicator,
    validPassword,
    validMaxLength,
    isEmpty,
    isIsoDate,
    formatDateTimeZoneWithHour,
    formatDateCurrent,
    groupByData,
    fomatDateTimeLocal,
    formatDateTimeLocalKintone,
    checkStatusExport
};
